import { render, staticRenderFns } from "./BusstopDetail.vue?vue&type=template&id=5751d24b&"
import script from "./BusstopDetail.vue?vue&type=script&lang=js&"
export * from "./BusstopDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports